import { atom } from "recoil";

export const countryDialogOpenedState = atom<boolean>({
  key: "countryDialogOpenedState",
  default: false,
});
